import NetInfo from '@react-native-community/netinfo'
import { useEffect } from 'react'

import { useToast } from '@/src/general/components/ToastContext'
import {
  addErrorListener,
  isUserActionNetworkError,
  type TNetworkErrorNotice,
} from '@/src/general/utilities/fetcher/interceptors'
import { hasInternetConnection, isConfirmedOffline } from '@/src/general/utilities/netinfo/connectivity'
import { useTranslate } from '@/src/lang/useTranslate'

import { ICON } from '../enums/icons'

/**
 * Toasts after a failed user mutation (POST/PATCH), once NetInfo allows a diagnosis:
 * - confirmed offline → not connected
 * - confirmed online → service unreachable
 */
export const UserActionNetworkErrorToasts = (): null => {
  const { addToast } = useToast()
  const { t } = useTranslate()

  // FIXME : Adding t in hook dependencies cause maximum depth updates
  const notConnectedText = t('app-service.not-connected')
  const serviceUnavailableText = t('app-service.unavailable.description')

  useEffect(() => {
    const onUserActionNetworkError = (error: TNetworkErrorNotice) => {
      if (!isUserActionNetworkError(error)) return
      void NetInfo.fetch().then((state) => {
        if (isConfirmedOffline(state)) {
          addToast({
            message: notConnectedText,
            colors: 'danger',
            iconName: ICON.WIFI_OFF,
          })
          return
        }

        if (hasInternetConnection(state)) {
          addToast({
            message: serviceUnavailableText,
            colors: 'danger',
            iconName: ICON.WIFI_OFF,
          })
        }
      })
    }

    return addErrorListener(onUserActionNetworkError)
  }, [notConnectedText, serviceUnavailableText, addToast])

  return null
}
